import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import { Button, Input, InputX, Layer, InputRed } from 'components'
import { showMyInfoEmailState } from 'views/member/states'
import { useRecoilState, useSetRecoilState } from 'recoil'
import Lib from 'library'
import App from 'App'

const MyInfoEmail = (userMail) => {

	const App = useApp()
	const [showMyInfoEmail, setShowMyInfoEmail] = useRecoilState(showMyInfoEmailState)

	const [emailRed, setEmailRed] = useState(false)
	const [email, setEmail] = useState(userMail.userMail) //이메일 값 담기
	const [buttonDisabled, setButtonDisabled] = useState(true) // 메인버튼 disabled 여부

	//이메일 입력할 때 
	const onEmailChange = e => {
		let value
		if (!e) { value = "" } else { value = e.target.value }
		setEmail(value)
	}

	//이메일 유효성체크
	const validate = () => {
		const regExp = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,4}$/i
		if (Lib.isNull(email) || !regExp.test(email)) {
			setEmailRed(true)
			return false
		} else {
			setEmailRed(false)
		}
		return true
	}

	useEffect(() => {
		setButtonDisabled(!validate())
	}, [email])

	//저장
	const saveEmailInfo = () => {
		Lib.post(`/api/more/myinfo/upd/email`, {
			email: email
		}, data => {
			App.showAlert("저장되었습니다.", () => {
				//이동할페이지 (레이어 닫기)
				setShowMyInfoEmail(false)
			})
		}, error => {
			if(error.code === "E300"){
				App.showAlert('인증이 완료되지 않았습니다')
				setShowMyInfoEmail(false)
			} else {
				App.showAlert('다시 시도해주세요')
				setShowMyInfoEmail(false)
			}
		})
	}

	useEffect(() => {
		if(showMyInfoEmail) {
			setEmail(userMail.userMail)
		}
	}, [showMyInfoEmail])

	return (
		<Layer show={showMyInfoEmail} closeLayer={() => setShowMyInfoEmail(false)}>
			<div className="page">
				<div className="flex_1 padding">
					<h3>이메일을 입력해주세요.</h3>

					<p className="guide-title mt_40">이메일 주소</p>
					<InputX className="mt_10" value={email === (null || undefined) ? "" : email} setValue={setEmail} name="email" type="email" placeholder="이메일 입력" onChange={onEmailChange}/>
					{/* <InputX value={userMail.userMail} setValue={setEmail} name="email" type="email" placeholder="이메일 입력" onChange={onEmailChange} /> */}
					
				<InputRed text="이메일을 정확히 입력해주세요." show={emailRed}/>
				</div>
				<div className="flex-shrink_0 padding">
					<Button className="btn btn--big" disabled={buttonDisabled} onClick={saveEmailInfo}>저장</Button>
				</div>
			</div>
		</Layer>
	)
}

export default MyInfoEmail
